export default {
  diffusionInputs: 'Dane wejściowe dyfuzji',
  partParameters: 'Parametry części',
  simulationValues: 'Wartości symulacji',
};
